import React from 'react';

/* External */
import PropTypes from 'prop-types';

/* Styles */
import './PlayerButton.scss';

function PlayerButton({
  className,
  onClick,
  children,
  tooltip,
  onMouseEnter,
  onMouseLeave,
  id,
}) {
  return (
    <button
      type="button"
      title={tooltip}
      className={`dtv-common-c-player-button-v2 ${className}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      id={id}
    >
      {children}
    </button>
  );
}

PlayerButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  id: PropTypes.string,
};

PlayerButton.defaultProps = {
  children: [],
  className: '',
  tooltip: '',
  onClick() {},
  onMouseEnter() {},
  onMouseLeave() {},
  id: '',
};

export default PlayerButton;
